import * as Yup from 'yup';

import { signUpDayOptions as defaultSignupDateOptions } from '../../../defaultFilters';

export const useSignupDateFilter = ({ setFilters }) => {
  const signupDateOptions = defaultSignupDateOptions;

  const formSchema = Yup.object().shape({
    signupDaysSinceJoined: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.mixed().required(),
    }),
  });

  const onSubmit = ({ signupDaysSinceJoined }) => {
    setFilters({ signupDaysSinceJoined });
  };

  return {
    formSchema,
    onSubmit,
    signupDateOptions,
  };
};
